import ConfigurationInstance from '../services/config/baseUrlConfigStore';

const cfgGetter = () => {
  return ConfigurationInstance.getBaseUrl();
};

export default cfgGetter;
